type ErrorStateProps = {
  message: string;
};

export function ErrorState({ message }: ErrorStateProps) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-6 text-center text-base font-medium text-red-700">
      {message}
    </main>
  );
}
